/*
    List of fonts to be imported by react-google-font-loader
    The list includes all fonts that contain italic versions of both 400 and 700 weight

    category is the font's generic CSS family (serif / sans-serif / monospace),
    used to pick a same-category fallback when the web font hasn't loaded yet.
*/

const fonts = [
  { font: 'Alegreya', weights: [400, '400i', 700, '700i'], category: 'serif' },
  { font: 'Alegreya SC', weights: [400, '400i', 700, '700i'], category: 'serif' },
  { font: 'Alegreya Sans', weights: [400, '400i', 700, '700i'], category: 'sans-serif' },
  { font: 'Alegreya Sans SC', weights: [400, '400i', 700, '700i'], category: 'sans-serif' },
  { font: 'Aleo', weights: [400, '400i', 700, '700i'], category: 'serif' },
  { font: 'Almendra', weights: [400, '400i', 700, '700i'], category: 'serif' },
  { font: 'Amaranth', weights: [400, '400i', 700, '700i'], category: 'sans-serif' },
  { font: 'Amiri', weights: [400, '400i', 700, '700i'], category: 'serif' },
  { font: 'Anonymous Pro', weights: [400, '400i', 700, '700i'], category: 'monospace' },
  { font: 'Archivo', weights: [400, '400i', 700, '700i'], category: 'sans-serif' },
  { font: 'Archivo Narrow', weights: [400, '400i', 700, '700i'], category: 'sans-serif' },
  { font: 'Arimo', weights: [400, '400i', 700, '700i'], category: 'sans-serif' },
  { font: 'Arsenal', weights: [400, '400i', 700, '700i'], category: 'sans-serif' },
  { font: 'Arvo', weights: [400, '400i', 700, '700i'], category: 'serif' },
  { font: 'Asap', weights: [400, '400i', 700, '700i'], category: 'sans-serif' },
  { font: 'Asap Condensed', weights: [400, '400i', 700, '700i'], category: 'sans-serif' },
  { font: 'Averia Libre', weights: [400, '400i', 700, '700i'], category: 'sans-serif' },
  { font: 'Averia Sans Libre', weights: [400, '400i', 700, '700i'], category: 'sans-serif' },
  { font: 'Averia Serif Libre', weights: [400, '400i', 700, '700i'], category: 'serif' },
  { font: 'B612', weights: [400, '400i', 700, '700i'], category: 'sans-serif' },
  { font: 'B612 Mono', weights: [400, '400i', 700, '700i'], category: 'monospace' },
  { font: 'Bai Jamjuree', weights: [400, '400i', 700, '700i'], category: 'sans-serif' },
  { font: 'Barlow', weights: [400, '400i', 700, '700i'], category: 'sans-serif' },
  { font: 'Barlow Condensed', weights: [400, '400i', 700, '700i'], category: 'sans-serif' },
  { font: 'Barlow Semi Condensed', weights: [400, '400i', 700, '700i'], category: 'sans-serif' },
  { font: 'Be Vietnam', weights: [400, '400i', 700, '700i'], category: 'sans-serif' },
  { font: 'Cabin', weights: [400, '400i', 700, '700i'], category: 'sans-serif' },
  { font: 'Cambay', weights: [400, '400i', 700, '700i'], category: 'sans-serif' },
  { font: 'Cantarell', weights: [400, '400i', 700, '700i'], category: 'sans-serif' },
  { font: 'Caudex', weights: [400, '400i', 700, '700i'], category: 'serif' },
  { font: 'Chakra Petch', weights: [400, '400i', 700, '700i'], category: 'sans-serif' },
  { font: 'Chivo', weights: [400, '400i', 700, '700i'], category: 'sans-serif' },
  { font: 'Cormorant', weights: [400, '400i', 700, '700i'], category: 'serif' },
  { font: 'Cormorant Garamond', weights: [400, '400i', 700, '700i'], category: 'serif' },
  { font: 'Cormorant Infant', weights: [400, '400i', 700, '700i'], category: 'serif' },
  { font: 'Cousine', weights: [400, '400i', 700, '700i'], category: 'monospace' },
  { font: 'Crimson Pro', weights: [400, '400i', 700, '700i'], category: 'serif' },
  { font: 'Crimson Text', weights: [400, '400i', 700, '700i'], category: 'serif' },
  { font: 'Cuprum', weights: [400, '400i', 700, '700i'], category: 'sans-serif' },
  { font: 'DM Sans', weights: [400, '400i', 700, '700i'], category: 'sans-serif' },
  { font: 'EB Garamond', weights: [400, '400i', 700, '700i'], category: 'serif' },
  { font: 'Economica', weights: [400, '400i', 700, '700i'], category: 'sans-serif' },
  { font: 'Exo', weights: [400, '400i', 700, '700i'], category: 'sans-serif' },
  { font: 'Exo 2', weights: [400, '400i', 700, '700i'], category: 'sans-serif' },
  { font: 'Expletus Sans', weights: [400, '400i', 700, '700i'], category: 'sans-serif' },
  { font: 'Fahkwang', weights: [400, '400i', 700, '700i'], category: 'sans-serif' },
  { font: 'Faustina', weights: [400, '400i', 700, '700i'], category: 'serif' },
  { font: 'Fira Sans', weights: [400, '400i', 700, '700i'], category: 'sans-serif' },
  { font: 'Fira Sans Condensed', weights: [400, '400i', 700, '700i'], category: 'sans-serif' },
  {
    font: 'Fira Sans Extra Condensed',
    weights: [400, '400i', 700, '700i'],
    category: 'sans-serif'
  },
  { font: 'GFS Neohellenic', weights: [400, '400i', 700, '700i'], category: 'sans-serif' },
  { font: 'Gentium Basic', weights: [400, '400i', 700, '700i'], category: 'serif' },
  { font: 'Gentium Book Basic', weights: [400, '400i', 700, '700i'], category: 'serif' },
  { font: 'Grenze', weights: [400, '400i', 700, '700i'], category: 'serif' },
  { font: 'IBM Plex Mono', weights: [400, '400i', 700, '700i'], category: 'monospace' },
  { font: 'IBM Plex Sans', weights: [400, '400i', 700, '700i'], category: 'sans-serif' },
  { font: 'IBM Plex Sans Condensed', weights: [400, '400i', 700, '700i'], category: 'sans-serif' },
  { font: 'IBM Plex Serif', weights: [400, '400i', 700, '700i'], category: 'serif' },
  { font: 'Istok Web', weights: [400, '400i', 700, '700i'], category: 'sans-serif' },
  { font: 'Josefin Sans', weights: [400, '400i', 700, '700i'], category: 'sans-serif' },
  { font: 'Josefin Slab', weights: [400, '400i', 700, '700i'], category: 'serif' },
  { font: 'K2D', weights: [400, '400i', 700, '700i'], category: 'sans-serif' },
  { font: 'Kanit', weights: [400, '400i', 700, '700i'], category: 'sans-serif' },
  { font: 'Karla', weights: [400, '400i', 700, '700i'], category: 'sans-serif' },
  { font: 'KoHo', weights: [400, '400i', 700, '700i'], category: 'sans-serif' },
  { font: 'Kodchasan', weights: [400, '400i', 700, '700i'], category: 'sans-serif' },
  { font: 'Krub', weights: [400, '400i', 700, '700i'], category: 'sans-serif' },
  { font: 'Lato', weights: [400, '400i', 700, '700i'], category: 'sans-serif' },
  { font: 'Libre Franklin', weights: [400, '400i', 700, '700i'], category: 'sans-serif' },
  { font: 'Literata', weights: [400, '400i', 700, '700i'], category: 'serif' },
  { font: 'Livvic', weights: [400, '400i', 700, '700i'], category: 'sans-serif' },
  { font: 'Lobster Two', weights: [400, '400i', 700, '700i'], category: 'serif' },
  { font: 'Lora', weights: [400, '400i', 700, '700i'], category: 'serif' },
  { font: 'Mali', weights: [400, '400i', 700, '700i'], category: 'sans-serif' },
  { font: 'Manuale', weights: [400, '400i', 700, '700i'], category: 'serif' },
  { font: 'Marvel', weights: [400, '400i', 700, '700i'], category: 'sans-serif' },
  { font: 'Merriweather', weights: [400, '400i', 700, '700i'], category: 'serif' },
  { font: 'Merriweather Sans', weights: [400, '400i', 700, '700i'], category: 'sans-serif' },
  { font: 'Montserrat', weights: [400, '400i', 700, '700i'], category: 'sans-serif' },
  { font: 'Montserrat Alternates', weights: [400, '400i', 700, '700i'], category: 'sans-serif' },
  { font: 'Muli', weights: [400, '400i', 700, '700i'], category: 'sans-serif' },
  { font: 'Niramit', weights: [400, '400i', 700, '700i'], category: 'sans-serif' },
  { font: 'Nobile', weights: [400, '400i', 700, '700i'], category: 'sans-serif' },
  { font: 'Noticia Text', weights: [400, '400i', 700, '700i'], category: 'serif' },
  { font: 'Noto Sans', weights: [400, '400i', 700, '700i'], category: 'sans-serif' },
  { font: 'Noto Serif', weights: [400, '400i', 700, '700i'], category: 'serif' },
  { font: 'Nunito', weights: [400, '400i', 700, '700i'], category: 'sans-serif' },
  { font: 'Nunito Sans', weights: [400, '400i', 700, '700i'], category: 'sans-serif' },
  { font: 'Open Sans', weights: [400, '400i', 700, '700i'], category: 'sans-serif' },
  { font: 'Overlock', weights: [400, '400i', 700, '700i'], category: 'sans-serif' },
  { font: 'Overpass', weights: [400, '400i', 700, '700i'], category: 'sans-serif' },
  { font: 'PT Sans', weights: [400, '400i', 700, '700i'], category: 'sans-serif' },
  { font: 'PT Serif', weights: [400, '400i', 700, '700i'], category: 'serif' },
  { font: 'Philosopher', weights: [400, '400i', 700, '700i'], category: 'serif' },
  { font: 'Playfair Display', weights: [400, '400i', 700, '700i'], category: 'serif' },
  { font: 'Playfair Display SC', weights: [400, '400i', 700, '700i'], category: 'serif' },
  { font: 'Poppins', weights: [400, '400i', 700, '700i'], category: 'sans-serif' },
  { font: 'Prompt', weights: [400, '400i', 700, '700i'], category: 'sans-serif' },
  { font: 'Proza Libre', weights: [400, '400i', 700, '700i'], category: 'sans-serif' },
  { font: 'Puritan', weights: [400, '400i', 700, '700i'], category: 'sans-serif' },
  { font: 'Quantico', weights: [400, '400i', 700, '700i'], category: 'sans-serif' },
  { font: 'Quattrocento Sans', weights: [400, '400i', 700, '700i'], category: 'sans-serif' },
  { font: 'Raleway', weights: [400, '400i', 700, '700i'], category: 'sans-serif' },
  { font: 'Rambla', weights: [400, '400i', 700, '700i'], category: 'sans-serif' },
  { font: 'Red Hat Display', weights: [400, '400i', 700, '700i'], category: 'sans-serif' },
  { font: 'Red Hat Text', weights: [400, '400i', 700, '700i'], category: 'sans-serif' },
  { font: 'Roboto', weights: [400, '400i', 700, '700i'], category: 'sans-serif' },
  { font: 'Roboto Condensed', weights: [400, '400i', 700, '700i'], category: 'sans-serif' },
  { font: 'Roboto Mono', weights: [400, '400i', 700, '700i'], category: 'monospace' },
  { font: 'Rosario', weights: [400, '400i', 700, '700i'], category: 'sans-serif' },
  { font: 'Rubik', weights: [400, '400i', 700, '700i'], category: 'sans-serif' },
  { font: 'Sansita', weights: [400, '400i', 700, '700i'], category: 'sans-serif' },
  { font: 'Sarabun', weights: [400, '400i', 700, '700i'], category: 'sans-serif' },
  { font: 'Scada', weights: [400, '400i', 700, '700i'], category: 'sans-serif' },
  { font: 'Share', weights: [400, '400i', 700, '700i'], category: 'sans-serif' },
  { font: 'Source Code Pro', weights: [400, '400i', 700, '700i'], category: 'monospace' },
  { font: 'Source Sans Pro', weights: [400, '400i', 700, '700i'], category: 'sans-serif' },
  { font: 'Space Mono', weights: [400, '400i', 700, '700i'], category: 'monospace' },
  { font: 'Spectral', weights: [400, '400i', 700, '700i'], category: 'serif' },
  { font: 'Spectral SC', weights: [400, '400i', 700, '700i'], category: 'serif' },
  { font: 'Taviraj', weights: [400, '400i', 700, '700i'], category: 'serif' },
  { font: 'Thasadith', weights: [400, '400i', 700, '700i'], category: 'sans-serif' },
  { font: 'Tinos', weights: [400, '400i', 700, '700i'], category: 'serif' },
  { font: 'Titillium Web', weights: [400, '400i', 700, '700i'], category: 'sans-serif' },
  { font: 'Trirong', weights: [400, '400i', 700, '700i'], category: 'serif' },
  { font: 'Ubuntu', weights: [400, '400i', 700, '700i'], category: 'sans-serif' },
  { font: 'Ubuntu Mono', weights: [400, '400i', 700, '700i'], category: 'monospace' },
  { font: 'Unna', weights: [400, '400i', 700, '700i'], category: 'serif' },
  { font: 'Volkhov', weights: [400, '400i', 700, '700i'], category: 'serif' },
  { font: 'Vollkorn', weights: [400, '400i', 700, '700i'], category: 'serif' },
  { font: 'Zilla Slab', weights: [400, '400i', 700, '700i'], category: 'serif' }
];

export default fonts;
